var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadArchiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.46967 12.5303C5.76256 12.8232 6.23744 12.8232 6.53033 12.5303L11.3033 7.75736C11.5962 7.46447 11.5962 6.98959 11.3033 6.6967C11.0104 6.40381 10.5355 6.40381 10.2426 6.6967L6 10.9393L1.75736 6.6967C1.46447 6.40381 0.989593 6.40381 0.696699 6.6967C0.403806 6.98959 0.403806 7.46447 0.696699 7.75736L5.46967 12.5303ZM6 0L5.25 3.27835e-08L5.25 12L6 12L6.75 12L6.75 -3.27835e-08L6 0Z",
    fill: "#2A3FBF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.75,
    y: 14.75,
    width: 9.5,
    height: 2.5,
    rx: 1.25,
    stroke: "#2A3FBF",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadArchiveIcon);
export default __webpack_public_path__ + "static/media/download-archive-icon.ee7716cc40f231ca331f1d6c3575cd95.svg";
export { ForwardRef as ReactComponent };